import { Article, BlogPosting } from 'schema-dts';

import { JsonLd } from '@sola/ark-skippy/atoms/json-ld/json-ld.tsx';
import { ArticleTemplate } from '@sola/ark-skippy/templates/article/article-template.tsx';
import {
  buildArticleJsonLd,
  getArticleSchemaType,
} from '@sola/ark-skippy/utils/schema-utils.ts';
import { LOCALES_CODES } from '@sola/contentful-model/lib/types.ts';
import { ArticleResponseDto } from '@sola/schema/lib/contentful.ts';

import { extractArgsArticle } from '../logic.tsx';

export const RenderArticle = ({
  article,
  locale,
  path,
  experiments,
}: {
  article: ArticleResponseDto;
  locale: LOCALES_CODES;
  path: string;
  experiments?: string[];
}) => {
  const props = extractArgsArticle(article);
  if (!props) {
    return;
  }

  const schemaType = getArticleSchemaType(props.taxonomyArticleType);

  // TODO: add logic for different types of articles with different templates
  return (
    <>
      <JsonLd<Article | BlogPosting>
        item={{
          '@context': 'https://schema.org',
          '@type': schemaType,
          ...buildArticleJsonLd(props, path),
        }}
      />
      <ArticleTemplate article={props} experiments={experiments} />
    </>
  );
};
